/*
dilip  10/10/2022   3075154998   changed Visibility To Datausage icon
dilip  10/10/2022   3075154998   visbility icon changed to Datausage
Raghu  26/10/2022   3075154998   Table Alignments and Enhancements
akhila  10/28/2022  3075154998 enable framework UX changes
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions
akhila 11/01/2022 3075154998 TablePagination bugFix
Suresh Peddavoora 11/03/2022 3075154998 Table Pagination Tab Responsive Fixes

*/
import React, {createRef, useEffect, useState, useContext} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
import {SuccessSnackbar} from '../../../../components/CustomSnackBar';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationPost, httpPaginationDelete} from '../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {fetchFilterUsage, printFilter} from '../../../../redux/reducers/EnableFramework/Filter';

import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import OverrideRule from './../../../../components/OverrideRule/index';
import DataUsageOutlinedIcon from '@material-ui/icons/DataUsageOutlined';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../constants/ReusableConstants';

export default function FilterSearchTable({
  setValueCode,
  searchData,
  setFilterCode,
  setFilterCodeName,
  submit,
  setSubmit,
  setIsCopyRowData,
  setUsageState,
  userMetrixDelete,
  isDelete,
  setIsDelete,
  isLoading,
  setDeleteUsage,
  setFieldRowData,
  fieldRowData,
  isUsage,
  setIsUsage,
}) {
  const [message, setMessage] = useState('');
  const [rows, setRows] = useState(defaultRows);

  const columns = [
    {
      title: 'Filter Code',
      field: 'name',
    },
    {
      title: 'Description',
      field: 'description',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
    },
  ];
  const [arrayLast, setArrayLast] = useState(false);

  const [deleteData, setDeleteData] = useState({});
  const [deleteRowInfo, setDeleteRowInfo] = useState(null);
  const [status, setStatus] = useState(false);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const tableRef = createRef();
  const dispatch = useDispatch();
  const {usageFilter} = useSelector(
    ({filter}) => filter,
  );

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  useEffect(() => {
    setIsCopyRowData(false);
  }, []);
  useEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);
  const handleDelete = (rowData) => {
    setDeleteRowInfo(rowData);
    setDeleteData(rowData);
    setDeleteUsage(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    httpPaginationDelete(`enableintegration/delete/filter/${deleteData?.id}`)
      .then((response) => {
        if (response?.status === 200) {
          setIsDelete(false);
          setStatus(true);
          setMessage(response?.response);
          setTimeout(() => {
            setMessage('');
          }, 3000);
        }
      })

      .catch((error) => {
        console.log(error);
      });
  };
  const handleDeleteUsage = () => {
    if (userMetrixDelete) {
      setFieldRowData(deleteRowInfo);
      setValueCode(2);
    } else {
      handleSubmit();
    }
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Filter Group"
        value={
          userMetrixDelete ?
            'This rule group is already being used' :
            `Are you sure you want to delete this rule group?`
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleDeleteUsage}
      />

      <OverrideRule
        dialogTitle="Delete Rule Group"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title="This Business Rule Engine has been used in the following frameworks."
        data={usageFilter?.placeResponse}
        isOverRide={false}
      />
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-actions-icon custom-toolbar-icons">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            isLoading={isLoading}
            data={(query) =>
              new Promise((resolve) => {
                const url = `enableintegration/search/filter`;
                const bodyObj = {
                  description: searchData?.description ? searchData?.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  name: searchData?.name ? searchData.name : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setFilterCode('');
                        setFilterCodeName('');
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            localization={{
              body: {editRow: {deleteText: 'Are you sure you want to delete this filter?'}},
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <FileCopyOutlinedIcon />
                  </>
                ),
                tooltip: 'copy',
                onClick: (event, rowData) => {
                  setFilterCode(rowData?.id);
                  setFilterCodeName(rowData?.name);
                  setIsCopyRowData(true);
                  setValueCode(1);
                },
              },
              {
                icon: () => <DataUsageOutlinedIcon className={classes.copyButtonroot} />,
                tooltip: 'Usage',
                onClick: (event, rowData) => {
                  setDeleteUsage(false);
                  dispatch(fetchFilterUsage(rowData.name));
                },
              },
              {
                icon: () => <DeleteOutlineOutlinedIcon/>,
                tooltip: 'Delete',
                onClick: (event, rowData) => {
                  handleDelete(rowData);
                  dispatch(fetchFilterUsage(rowData.name));
                },
              },
              // commented for future use
              // {
              //   icon: () => (
              //     <>
              //       <Button
              //         type="button"
              //         variant="contained"
              //         className={`themeing-buttons ${classes.buttonRoot}`}
              //         color="primary"
              //       >
              //         Print Usage
              //       </Button>
              //     </>
              //   ),
              //   tooltip: "Print Usage",
              //   isFreeAction: true,
              //   onClick: (event) => {},
              // },
              {
                icon: () => (
                  <>
                    <Button
                      variant="outlined"
                      className={`mx-1 search-btn`}>
                      Add Filter
                    </Button>
                  </>
                ),
                tooltip: '',
                isFreeAction: true,
                onClick: (event) => {
                  setValueCode(1);
                },
              },
            ]}
            onRowClick={(event, rowData) => {
              setFilterCode(rowData?.id);
              setFilterCodeName(rowData?.name);
              setValueCode(1);
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">
                    <Button
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      onClick={() => {
                        dispatch(
                          printFilter({
                            description: searchData?.description ? searchData?.description : '',
                            name: searchData?.name ? searchData.name : '',
                          }),
                        );
                      }}
                    >
                      Print
                    </Button>
                  </div>
                  <div style={{backgroundColor: 'white', border: '0px'}}>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
          {message && <SuccessSnackbar successMsg={message} />}
        </div>
      </Grid>
    </>
  );
}
